<template lang="pug">
  div
    div
      .form-group.row.required.justify-content-center.position-relative.mb-6
        .dashed-line.col-9
        .steps-wrapper.col-12.justify-content-between.overflow-unset.p-0
          .d-flex.flex-column.align-items-center.col-3(:class="{'step_active': step === 1 }")
            .step__number.mr-0
              .fal.fa-map-marker-alt
            .step__content Localisation
          .d-flex.flex-column.align-items-center.col-3(:class="{'step_active': step === 2 }")
            .step__number.mr-0
              .fal.fa-user
            .step__content Identité
          .d-flex.flex-column.align-items-center.col-3(:class="{'step_active': step === 3 }")
            .step__number.mr-0
              .fal.fa-calendar-alt
            .step__content RDV
      .form-group.row.required.justify-content-center(v-if="step === 1")
        .mb-4.col-11
          h4 Prenez un rendez-vous proche de chez vous en 2 minutes
        .searchbar.searchbar-rounded
          i.fal.fa-map-marker-alt
          autocomplete-geolocation(@address-changed="nextStep")

      div(v-if="step === 2")
        loading-wrapper(:loading="loading")
        form-errors(:errors="errors")
        .row.form-group.required
          .col-md-12
            .position-center.position-left.fal.fa-map-marker-check.fa-lg
            input.pl-5(type="text" v-model="mutableAppointmentRequest.attributes.address_attributes.display_name" disabled class="form-control")
            a.position-center.position-right(@click.prevent="previousStep")
              .fal.fa-undo
          .col-md-6.text-left.font-sbold.text-primary {{ `${practitionerCount} ostéopathes dans votre secteur`}}
        .row.form-group.required
          .col-md-2.pr-0
            .form-label.text-left
              label Nom
          .col-md-10
            input(type="text" v-model="mutableAppointmentRequest.attributes.lastname" name="appointment_request[lastname]" id="appointment_request_lastname" class="form-control")

        .row.form-group.required
          .col-md-2.pr-0
            .form-label.text-left
              label Prénom
          .col-md-10
            input(type="text" v-model="mutableAppointmentRequest.attributes.firstname" name="appointment_request[firstname]" id="appointment_request_firstname" class="form-control")

        .row.form-group.required
          .col-md-2.pr-0
            .form-label.text-left
              label Téléphone
          .col-md-10
            input(type="text" v-model="mutableAppointmentRequest.attributes.phone" name="appointment_request[phone]" id="appointment_request_phone" class="form-control")

        .row.form-group.required
          .col-md-2.pr-0
            .form-label.text-left
              label Email
          .col-md-10
            input(type="text" v-model="mutableAppointmentRequest.attributes.email" name="appointment_request[email]" id="appointment_request_email" class="form-control")

        .text-center
          p.text-sm
            | REFLEX OSTEO s&apos;engage &agrave; respecter vos donn&eacute;es. En continuant votre demande de rendez-vous, vous acceptez nos
            a(href='https://www.reflexosteo.com/basic_pages/mentions-legales-reflexosteo-1')  Mentions l&eacute;gales.
            br

      div(v-if="step === 3")
        form-errors(:errors="errors")
        home-care-time-slots(:periods="periods" :availabilities="availabilities" @change="setTimeSlotsAttributes")
        hr
        .form-group
          label.form-label(for='appointment_request_comment') Vous pouvez si vous le souhaitez pr&eacute;ciser votre demande.
          textarea#appointment_request_comment.form-control(v-model="mutableAppointmentRequest.attributes.comment" rows='4' placeholder='Je souhaite le RDV dès que possible, à partir de 17h, ce soir ou demain dans la journée etc...' name='appointment_request[comment]')


      .form-group.row.justify-content-center.mt-5(v-if="step > 1")
        button.btn.btn-default.mr-5.forward(@click.prevent="previousStep" v-if="step === 2")
          span Retour
        button.btn.btn-primarysmooth.forward(type="submit" v-if="step === 2" @click.prevent="onCaptchaVerified")
          span Prendre RDV
        button.btn.btn-primarysmooth.forward.mb-5(@click.prevent="submit" v-else)
          span Envoyer
    .card.forward.transparent(v-if="step === 2")
      hr
      .card-body.mb-5
        h2.h4.mb-4 Ou par téléphone
        a.btn.btn-phone(:href="`tel:${switchboardLink}`")
          span Pour prendre RDV
          span {{ switchboard }}

</template>

<script>
import AutocompleteGeolocation from '@appComponents/AutocompleteGeolocation'
import HomeCareTimeSlots from '@appComponents/HomeCareTimeSlots'
import axios from 'axios'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteGeolocation,
    HomeCareTimeSlots,
    LoadingWrapper: () => import('@sharedComponents/LoadingWrapper'),
    FormErrors: () => import('@sharedComponents/FormErrors')
  },
  props: {
    initialAppointmentRequest: Object,
    periods: Array,
    availabilities: Array,
    initialSwitchboardLink: String,
    initialSwitchboard: String
  },
  data () {
    return {
      step: 1,
      loading: false,
      mutableAppointmentRequest: {
        attributes: {
          id: null,
          firstname: get(this.initialAppointmentRequest, 'firstname'),
          lastname: get(this.initialAppointmentRequest, 'lastname'),
          phone: get(this.initialAppointmentRequest, 'phone'),
          email: get(this.initialAppointmentRequest, 'email'),
          zone_id: null,
          comment: '',
          address_attributes: {
            street_number: null,
            street_name: null,
            city: null,
            postal_code: null,
            display_name: null,
            latitude: null,
            longitude: null,
            light: true
          },
          time_slots_attributes: null,
          origin_request: 'general_appointment'
        }
      },
      practitionerCount: null,
      switchboardLink: this.initialSwitchboardLink,
      switchboard: this.initialSwitchboard,
      errors: []
    }
  },
  methods: {
    nextStep (value) {
      if (value && this.step === 1) {
        const address = {
          street_number: value.address_components.filter(obj => { return obj.types[0] === "street_number" }),
          street_name: value.address_components.filter(obj => { return obj.types[0] === "route" }),
          city: value.address_components.filter(obj => { return obj.types[0] === "locality" }),
          postal_code: value.address_components.filter(obj => { return obj.types[0] === "postal_code" }),
          display_name: value.formatted_address,
          latitude: value.geometry.location.lat(),
          longitude: value.geometry.location.lng()
        }
        this.setAddress(address)
        this.step++
      }
    },
    onCaptchaVerified () {
      this.loading = true
      const recaptchaToken = document.getElementById('g-recaptcha-response-data-create-appointment-requests').value
      axios.post(`/rendez-vous-cabinet`, {
        appointment_request: this.mutableAppointmentRequest.attributes,
        "g-recaptcha-response-data": {
          create_appointment_requests: recaptchaToken
        }
      })
        .then((response) => {
          this.setAppointmentRequestAttributes(response.data)
          localStorage.setItem('step', this.step)
          localStorage.setItem('address', JSON.stringify(this.localisation))
          this.errors = []
          this.step++
          this.loading = false
        })
        .catch((error) => {
          this.errors = error.response.data
          localStorage.clear()
          this.loading = false
        })
    },
    previousStep () {
      this.step -= 1
      this.errors = []
    },
    submit () {
      this.loading = true
      axios.put(`/rendez-vous-cabinet/${this.mutableAppointmentRequest.attributes.token}`, {
        appointment_request: {
          comment: this.mutableAppointmentRequest.attributes.comment,
          time_slots_attributes: this.mutableAppointmentRequest.attributes.time_slots_attributes ? this.mutableAppointmentRequest.attributes.time_slots_attributes : null,
          id: this.mutableAppointmentRequest.attributes.id
        }
      })
        .then((response) => {
          window.location = response.data.redirect
          localStorage.clear()
          this.loading = false
        })
        .catch((error) => {
          this.errors = error.response.data
          localStorage.clear()
          this.loading = false
        })
    },
    setAddress (address) {
      this.mutableAppointmentRequest.attributes.address_attributes.street_number = address.street_number.length > 0 ? address.street_number[0].long_name : null
      this.mutableAppointmentRequest.attributes.address_attributes.street_name = address.street_name.length > 0 ? address.street_name[0].long_name : null
      this.mutableAppointmentRequest.attributes.address_attributes.city = address.city.length > 0 ? address.city[0].long_name : null
      this.mutableAppointmentRequest.attributes.address_attributes.postal_code = address.postal_code.length > 0 ? address.postal_code[0].long_name : null
      this.mutableAppointmentRequest.attributes.address_attributes.display_name = address.display_name
      this.mutableAppointmentRequest.attributes.address_attributes.latitude = address.latitude
      this.mutableAppointmentRequest.attributes.address_attributes.longitude = address.longitude
    },
    setAppointmentRequestAttributes (attributes) {
      this.mutableAppointmentRequest.attributes.token = attributes.token
      this.mutableAppointmentRequest.attributes.id = attributes.id
    },
    setTimeSlotsAttributes (attributes) {
      this.mutableAppointmentRequest.attributes.time_slots_attributes = Array.isArray(attributes) ? [...attributes] : [attributes]
    }
  },
  watch: {
    "mutableAppointmentRequest.attributes.address_attributes.latitude" () {
      let action = 'getZoneByAddress'
      this.$store.dispatch(action, { localisation: { attributes: this.mutableAppointmentRequest.attributes.address_attributes } })
        .then((response) => {
          this.switchboard = response.attributes.switchboard
          this.switchboardLink = response.attributes.switchboard_link
          this.practitionerCount = response.attributes.practitioners_count > 0 ? response.attributes.practitioners_count : 1
          this.mutableAppointmentRequest.attributes.zone_id = response.id
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .overflow-unset {
    overflow: unset;
  }
  .position-center {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #00BFFF;
    cursor: pointer;
  }
  .position-left {
    left: 23px;
    right: unset;
  }
  .position-right {
    right: 20px;
    left: unset;
  }

  .step__number {
    font-size: 2.5rem;
    height: 5rem;
    width: 5rem;
  }

  .card-body {
    border-radius: 40px;
  }

  .mb-6 {
    margin-bottom: 5rem;
  }

  .transparent {
    background: transparent;
  }

  @media (max-width: 767px) {
    .steps-wrapper .step__number {
      height: 4rem;
      width: 4rem;
      font-size: 2rem;
    }
    .mb-6 {
      margin-bottom: 3.5rem;
    }
  }

</style>
